import { TextFilter } from './TextFilter';

export class CategoryFilter extends TextFilter {

}


// WEBPACK FOOTER //
// ./resources/assets/js/Services/Search/CategoryFilter.js